import { render } from "./SubstitutesTreePage.vue?vue&type=template&id=54f7f92e&scoped=true"
import script from "./SubstitutesTreePage.vue?vue&type=script&lang=js"
export * from "./SubstitutesTreePage.vue?vue&type=script&lang=js"

import "./SubstitutesTreePage.vue?vue&type=style&index=0&id=54f7f92e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f7f92e"]])

export default __exports__